import { isNonNullable } from "../../../lib/utils";
export var DEFAULT_MASK_CHAR = '_';
export var DEFINITIONS = Object.freeze({
  '9': /[0-9]/,
  a: /[A-Za-z]/,
  '*': /[A-Za-z0-9]/
});
export function getDefinitions(formatChars) {
  if (isNonNullable(formatChars)) {
    var chars = {};
    for (var key in formatChars) {
      chars[key] = new RegExp(formatChars[key]);
    }
    return chars;
  }
  return DEFINITIONS;
}
export function getMaskChar(maskChar) {
  return !maskChar ? DEFAULT_MASK_CHAR : maskChar;
}